import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Toast } from 'react-vant'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { useSendCode } from '@/hooks/useSendCode'
import { APIWeb } from '@/api'
import { useTransactionRefresh } from '@/hooks'

export default React.memo(function VerificationCode() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { sendCodeLoading, sendCode } = useSendCode()
  const { refreshAfterTransaction } = useTransactionRefresh()
  const [submitLoading, setSubmitLoading] = useState(false)

  // 重新发送验证码
  const handleResendCode = async () => {
    await sendCode({ account: state?.account || '', scene: 'register' })
  }

  // 提交验证码
  const handleSubmit = async (code: string) => {
    if (!state?.account) return

    // 邮箱注册：跳转到设置密码页面
    if (state.type === 'email') {
      navigate(`/register/set-password`, {
        state: {
          account: state.account,
          code,
          inviteCode: state?.inviteCode, // 传递邀请码
        }
      })
      return
    }

    // 手机注册：直接完成注册
    if (state.type === 'phone') {
      setSubmitLoading(true)
      try {
        const data = await APIWeb.register({
          account: state.account,
          code,
          invite_code: state?.inviteCode, // 传递邀请码
        })

        // 保存 token
        if (data?.token) {
          localStorage.setItem('token', data.token)
          await refreshAfterTransaction()

          Toast.success({
            message: t('注册成功'),
            duration: 1500,
            onClose: () => {
              navigate('/home', { replace: true })
            }
          })
        }
      } catch (error: any) {
        console.error('注册失败:', error)
      } finally {
        setSubmitLoading(false)
      }
    }
  }

  return (
    <PageLayout>
      <Header leftChildren={<Back />} centerChildren={<div className='text-3.75 font-medium text-black'>{t('验证')}</div>} />
      {/* Content */}
      <div className="flex-1 overflow-y-auto px-6 py-6">
        <VerificationCodeInput
          account={state?.account || ''}
          onResendCode={handleResendCode}
          onSubmit={handleSubmit}
          resendLoading={sendCodeLoading}
          submitLoading={submitLoading}
          submitButtonText={t('确认')}
        />
      </div>
    </PageLayout>
  )
})